export default [{
    path: '/permissions',
    name: 'permissions',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/permissions/index')
  }]
  